export const languagesList = {
  language: [
    { id: 1, label: 'Afrikaans - Afrikaans', value: 'Afrikaans', code: 'af' },
    { id: 2, label: 'العربية - Arabic', value: 'Arabic', code: 'ar' },
    { id: 3, label: 'Հայերեն - Armenian', value: 'Armenian', code: 'hy' },
    { id: 4, label: 'Azərbaycanca - Azerbaijani', value: 'Azerbaijani', code: 'az' },
    { id: 5, label: 'Беларуская - Belarusian', value: 'Belarusian', code: 'be' },
    { id: 6, label: 'Bosanski - Bosnian', value: 'Bosnian', code: 'bs' },
    { id: 7, label: 'Български - Bulgarian', value: 'Bulgarian', code: 'bg' },
    { id: 8, label: 'Català - Catalan', value: 'Catalan', code: 'ca' },
    { id: 9, label: '中國人 - Chinese', value: 'Chinese', code: 'zh-CN' },
    { id: 10, label: 'Hrvatski - Croatian', value: 'Croatian', code: 'hr' },
    { id: 11, label: 'Čeština - Czech', value: 'Czech', code: 'cs' },
    { id: 12, label: 'Dansk - Danish', value: 'Danish', code: 'da' },
    { id: 13, label: 'Nederlands - Dutch', value: 'Dutch', code: 'nl' },
    { id: 14, label: 'English - English', value: 'English', code: 'en' },
    { id: 15, label: 'Eesti - Estonian', value: 'Estonian', code: 'et' },
    { id: 16, label: 'Suomi - Finnish', value: 'Finnish', code: 'fi' },
    { id: 17, label: 'Français - French', value: 'French', code: 'fr' },
    { id: 18, label: 'Galego - Galician', value: 'Galician', code: 'gl' },
    { id: 19, label: 'Deutsch - German', value: 'German', code: 'de' },
    { id: 20, label: 'Ελληνικά - Greek', value: 'Greek', code: 'el' },
    { id: 21, label: 'עברית - Hebrew', value: 'Hebrew', code: 'iw' },
    { id: 22, label: 'हिन्दी - Hindi', value: 'Hindi', code: 'hi' },
    { id: 23, label: 'Magyar - Hungarian', value: 'Hungarian', code: 'hu' },
    { id: 24, label: 'Íslenska - Icelandic', value: 'Icelandic', code: 'is' },
    { id: 25, label: 'Italiano - Italian', value: 'Italian', code: 'it' },
    { id: 26, label: '日本語 - Japanese', value: 'Japanese', code: 'ja' },
    { id: 27, label: 'ಕನ್ನಡ - Kannada', value: 'Kannada', code: 'kn' },
    { id: 28, label: 'Қазақ - Kazakh', value: 'Kazakh', code: 'kk' },
    { id: 29, label: '한국어 - Korean', value: 'Korean', code: 'ko' },
    { id: 30, label: 'Македонски - Macedonian', value: 'Macedonian', code: 'mk' },
    { id: 31, label: 'Bahasa Melayu - Malay', value: 'Malay', code: 'ms' },
    { id: 32, label: 'Māori - Maori', value: 'Maori', code: 'mi' },
    { id: 33, label: 'मराठी - Marathi', value: 'Marathi', code: 'mr' },
    { id: 34, label: 'ਪੰਜਾਬੀ - Panjabi', value: 'Punjabi', code: 'pa' },
    { id: 35, label: 'فارسی - Persian', value: 'Persian', code: 'fa' },
    { id: 36, label: 'Polski - Polish', value: 'Polish', code: 'pl' },
    { id: 37, label: 'Português - Portuguese', value: 'Portuguese', code: 'pt' },
    { id: 38, label: 'Română - Romanian', value: 'Romanian', code: 'ro' },
    { id: 39, label: 'Русский - Russian', value: 'Russian', code: 'ru' },
    { id: 40, label: 'Српски - Serbian', value: 'Serbian', code: 'sr' },
    { id: 41, label: 'Slovenčina - Slovak', value: 'Slovak', code: 'sk' },
    { id: 42, label: 'Slovenščina - Slovenian', value: 'Slovenian', code: 'sl' },
    { id: 43, label: 'Español - Spanish', value: 'Spanish', code: 'es' },
    { id: 44, label: 'Kiswahili - Swahili', value: 'Swahili', code: 'sw' },
    { id: 45, label: 'Svenska - Swedish', value: 'Swedish', code: 'sv' },
    { id: 46, label: 'தமிழ் - Tamil', value: 'Tamil', code: 'ta' },
    { id: 47, label: 'ไทย - Thai', value: 'Thai', code: 'th' },
    { id: 48, label: 'Türkçe - Turkish', value: 'Turkish', code: 'tr' },
    { id: 49, label: 'Українська - Ukrainian', value: 'Ukrainian', code: 'uk' },
    { id: 50, label: 'اردو - Urdu', value: 'Urdu', code: 'ur' },
    { id: 51, label: 'Tiếng Việt - Vietnamese', value: 'Vietnamese', code: 'vi' },
    { id: 52, label: 'Cymraeg - Welsh', value: 'Welsh', code: 'cy' },
    { id: 53, label: 'Indonesia - Indonesian', value: 'Indonesian', code: 'id' },
    { id: 54, label: 'Latviski - Latvian', value: 'Latvian', code: 'lv' },
    { id: 55, label: 'Lietuvių - Lithuanian', value: 'Lithuanian', code: 'lt' },
    { id: 56, label: 'नेपाली - Nepali', value: 'Nepali', code: 'ne' },
    { id: 57, label: 'Norsk - Norwegian', value: 'Norwegian', code: 'no' },
    { id: 58, label: 'Tagalog - Tagalog', value: 'Tagalog', code: 'tl' },
  ],
};

languagesList.language.sort((a, b) => a.value.localeCompare(b.value));
